import { render, staticRenderFns } from "./GzFooter.vue?vue&type=template&id=607d5cf4&"
import script from "./GzFooter.vue?vue&type=script&lang=js&"
export * from "./GzFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports